/* eslint-disable no-unused-vars */
import { i18n } from '../../i18n'
import { getDirectionsAndCategories, processDocument, getCalendar, getPerformers, modifyWorkRequests, getAdditionalInformation, getWorkRequests, addWorkRequest, getDocumentInfo } from '../../api/workrequests/api.js'

const hasLatestWorkRequestsKey = 'eamHasLatestWorkRequestsChecked'

const state = {
  workRequests: [],
  comment: '',
  responsibleList: [],
  comments: [],
  attachments: [],

  additionalInformation: [],
  calendar: [],
  confirmationList: [],
  workRequestDirections: [],
  workRequestCategories: [],

  hasLatestWorkRequests: false,
  hasLatestWorkRequestsDialog: false,

  workRequestStageMessage: null
}

const getters = {
  workRequests: state => state.workRequests,
  workRequestDirections: state => state.workRequestDirections,
  workRequestCategories: state => state.workRequestCategories,
  hasLatestWorkRequests: state => state.hasLatestWorkRequests,
  hasLatestWorkRequestsDialog: state => state.hasLatestWorkRequestsDialog,
}

const actions = {
  async updateWorkRequests({ state, commit, getters, dispatch }, payload) {
    if (getters.isAuthenticated && getters.isOnline) {
      if (!payload.processInBackGround) {
        commit('setLoading', true)
      }
      try {

        if (!payload || !payload.workRequestId) {
          commit('setWorkRequests', [])
        }
        let data = []

        data = await getWorkRequests({ workRequestId: payload && payload.workRequestId ? payload.workRequestId : 0,
          filterMode: payload ? payload.filterMode : null, 
          additionalParams: { 
            showArchive: payload.showArchive ? payload.showArchive : false,
            dateFrom: payload.dateFrom ? payload.dateFrom : null, 
            dateTo: payload.dateTo ? payload.dateTo : null
          }
        })

        if (data && data.length) {
          data.forEach(item => {
            item.startDate = parseDate(item.DatePlanString) //m.format("YYYY-MM-DD")
            item.endDate = parseDate(item.DatePlanEndString)
          })
        }
        if (!payload.processInBackGround) {
          commit('setLoading', false)
        }
        if (!payload || !payload.workRequestId) {
          commit('setWorkRequests', data)
        }
        else if (data && data.length) {
          let currentWorkRequest = state.workRequests.find(wr => { return wr.IdApplication == data[0].IdApplication })
          if (currentWorkRequest) {
            Object.assign(currentWorkRequest, data[0])
          }
          else {
            state.workRequests.unshift(data[0])
          }
        }

        if (!data.length && !getters.isAuthenticated) {
          dispatch('openLoginDialog')
        }
      }
      catch (error) {
        commit('setError', error.message)
        if (!payload.processInBackGround) {
          commit('setLoading', false)
        }
      }
    } else {
      commit('setWorkRequests', [])
    }
  },
  async updateCalendar({ commit, getters }, payload) {
    if (getters.isAuthenticated && getters.isOnline) {
      commit('setLoading', true)
      try {
        commit('setCalendar', [])
        const data = await getCalendar(payload)
        commit('setLoading', false)
        if (data) {
          commit('setCalendar', data)
        }
      }
      catch (error) {
        commit('setError', error.message)
        commit('setLoading', false)
      }
    }
  },
  async updateAdditionalInformation({ commit, getters }, payload) {
    if (getters.isAuthenticated && getters.isOnline) {
      commit('setLoading', true)
      try {
        commit('setAdditionalInformation', [])
        const data = await getAdditionalInformation(payload)
        commit('setLoading', false)
        if (data && data.length == 0) {
          data.push({ email: '', telephone: '', fio: 'Не найдено информацию' })
        }
        commit('setAdditionalInformation', data)
      }
      catch (error) {
        commit('setError', error.message)
        commit('setLoading', false)
      }
    }
  },
  async modifyWorkRequests({ commit, dispatch, getters }, payload) {
    if (getters.isAuthenticated && getters.isOnline) {
      commit('setLoading', true)
      try {
        const data = await modifyWorkRequests(payload)
        commit('setLoading', false)
        if (data) {
          dispatch('updateWorkRequests', { workRequestId: payload.workRequestId })
        } else {
          commit('setError', 'Не удалось выполнить действие')
          commit('setLoading', false)
        }
      }
      catch (error) {
        commit('setError', error.message)
        commit('setLoading', false)
      }
    }
  },
  async workRequestStage({ commit, dispatch, getters }, payload) {
    if (getters.isAuthenticated && getters.isOnline) {
      commit('setLoading', true)
      try {
        const data = await processDocument(payload)
        commit('setLoading', false)
        if (data) {
          if (data.SUCCESS) {
            dispatch('updateWorkRequests', { workRequestId: payload.workRequestId })
          }
          else if (data.LOG) {
            commit('setWorkRequestStageMessage', data.LOG)
          }
        } else {
          commit('setError', 'Не удалось выполнить действие')
          commit('setLoading', false)
        }
      }
      catch (error) {
        commit('setError', error.message)
        commit('setLoading', false)
      }
    }
  },
  async clearWorkRequestStageMessage({ commit }) {
    commit('setWorkRequestStageMessage', null)
  },
  async checkLatestWorkRequests({ commit, dispatch, getters }) {
    await dispatch('updateWorkRequests', { filterMode: 'latest', processInBackGround: true })
    if (getters.workRequests && getters.workRequests.length) {
      commit('setHasLatestWorkRequests', getters.workRequests.length)
      dispatch('checkLatestWorkRequestsDialog')
    }
  },
  checkLatestWorkRequestsDialog({ commit, dispatch, getters }) {
    if (getters.hasLatestWorkRequests) {
      const cacheDate = new Date(localStorage.getItem(hasLatestWorkRequestsKey))
      let limitDate = new Date()
      limitDate.setDate(limitDate.getDate() - 1)
      if (cacheDate < limitDate) {
        commit('setHasLatestWorkRequestsDialog', true)
      }
    }
  },
  hideLatestWorkRequestsDialog({ commit, dispatch, getters }) {
    commit('setHasLatestWorkRequestsDialog', false)
    localStorage.setItem(hasLatestWorkRequestsKey, new Date())
  },
  async updatePerformers({ commit, getters }, payload) {
    if (getters.isAuthenticated && getters.isOnline) {
      commit('setLoading', true)
      try {
        commit('setResponsibleList', [])
        const data = await getPerformers(payload)
        commit('setLoading', false)
        if (data && data.length == 0) {
          data.push({ Code: '', Name: 'Не найдено исполнителей' })
        }
        commit('setResponsibleList', data)
      }
      catch (error) {
        commit('setError', error.message)
        commit('setLoading', false)
      }
    }
  },
  async updateComments({ commit, getters }, payload) {
    if (getters.isAuthenticated && getters.isOnline) {
      commit('setLoading', true)
      try {
        commit('setComments', [])
        const data = await getDocumentInfo(payload)
        commit('setLoading', false)
        if (data && data.COMMENTS && data.COMMENTS.length) {
          commit('setComments', data.COMMENTS)
        }
      }
      catch (error) {
        commit('setError', error.message)
        commit('setLoading', false)
      }
    }
  },

  async updateDirectionsAndCategories({ commit, state }) {
    if (!state.workRequestDirections.length) {
      const data = await getDirectionsAndCategories()
      commit('setWorkRequestData', data)
      return data
    }
  },
  async addWorkRequest({
    commit,
    dispatch,
    getters
  }, payload) {
    commit('setLoading', true)
    try {
      const workRequestId = await addWorkRequest(getters.isAuthenticated, payload.params, payload.imageFiles)
      commit('setLoading', false)
      if (workRequestId) {
        commit('setSnackbarData', {
          color: 'green',
          text: i18n.t('equipment.addWorkRequests.success', [workRequestId])
        })
        dispatch('updateEquipmentData', {
          equipmentCode: getters.equipmentData.EquipmentId,
          skipCache: true
        })
        dispatch('updateWorkRequests', {
          workRequestId,
          skipCache: true
        })
      } else {
        commit('setSnackbarData', {
          color: 'red',
          text: i18n.t('errors.workRequestNotAdded')
        })
        commit('setError', i18n.t('errors.workRequestNotAdded'))
      }
    } catch (error) {
      commit('setError', error.message)
      commit('setLoading', false)
    }
  },
  async updateWorkRequestAttachments({ dispatch }, payload) {
    dispatch('updateAttachments', { table: 'RZA', keyValue: payload.workRequestId.toString().padStart(7, ' ') })
  },
}

const mutations = {
  setHasLatestWorkRequests(state, payload) {
    state.hasLatestWorkRequests = payload
  },
  setHasLatestWorkRequestsDialog(state, payload) {
    state.hasLatestWorkRequestsDialog = payload
  },
  setWorkRequests(state, payload) {
    state.workRequests = payload
  },
  setComment(state, payload) {
    state.comment = payload
  },
  setResponsibleList(state, payload) {
    state.responsibleList = payload
  },
  setComments(state, payload) {
    state.comments = payload
  },
  setWorkRequestStageMessage(state, payload) {
    state.workRequestStageMessage = payload
  },
  setWorkRequestData(state, payload) {
    state.workRequestDirections = payload.Directions
    state.workRequestCategories = payload.Categories
  },
  setCalendar(state, payload) {
    state.calendar = payload
  },
  setAdditionalInformation(state, payload) {
    state.additionalInformation = payload
  },
  setConfirmationList(state, payload) {
    state.confirmationList = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}

function parseDate(date) {
  if (!date || !date.length) { return null }

  const [day, month, year] = date.substr(0, 10).split('.')
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}